/**
 * Utility functions for API Loader
 * # ⛓️ CURSOR_ANCHOR:search:api-loader-utils
 */

(function() {
  'use strict';

  /**
   * Функция для проверки пасхалок
   */
  function checkEasterEgg(searchTerm, currentLang, container) {
    if (currentLang === 'ru') {
      try {
        var base64 = '0L/QvtC60LDQutCw0Ls=';
        var binaryString = atob(base64);
        var decodedTerm = decodeURIComponent(escape(binaryString));
        if (searchTerm.toLowerCase() === decodedTerm.toLowerCase()) {
          container.innerHTML = '<p><b>ПОКАКАЛ - ОБРЯД ТАЙНОГО ОСНОВАТЕЛЯ ЧКПЧ...</b></p> <img width="350px" src="/pics/sticker.gif" >';
          var searchButton = document.querySelector('.search-button');
          if (searchButton) {
            searchButton.classList.remove('loading');
          }
          return true;
        }
      } catch (e) {}
    }
    return false;
  }

  /**
   * Функция для очистки старых результатов
   */
  function cleanupOldResults(container) {
    var oldMorphWrappers = container.querySelectorAll('.morph-wrapper');
    oldMorphWrappers.forEach(function(wrapper) {
      if (wrapper.parentNode === container) {
        container.removeChild(wrapper);
      }
    });
    
    var existingResults = container.querySelectorAll('.opredelenie');
    var hasSearchResults = existingResults.length > 0;
    
    if (!hasSearchResults) {
      var allResultElements = container.querySelectorAll('[data-search-result="true"]');
      if (allResultElements.length > 0) {
        var elementsToRemove = Array.from(allResultElements);
        elementsToRemove.forEach(function(element) {
          if (element.parentNode === container) {
            container.removeChild(element);
          }
        });
      }
      
      if (container.children.length > 0) {
        container.innerHTML = '';
      }
    }
  }

  /**
   * Функция для формирования параметров запроса
   */
  function buildSearchParams(searchTerm, searchType, currentLang) {
    // Миграция и валидация типа поиска
    if (!searchType || searchType === 'exact' || searchType === 'broad' || 
        searchType === 'description' || searchType === 'broad-without-vector' || 
        searchType === '') {
      searchType = 'classical';
    } else if (searchType === 'broad-with-vector') {
      searchType = 'smart';
    }
    
    // Если тип поиска все еще не один из разрешенных, сбрасываем в smart
    if (searchType !== 'smart' && searchType !== 'classical') {
      searchType = 'smart';
    }

    var searchParams = {
      lang: currentLang,
      search: searchTerm,
      type: searchType
    };
    
    if (window.SEARCH_HISTORY && window.SEARCH_HISTORY.getHiddenDicts) {
      var hiddenDicts = window.SEARCH_HISTORY.getHiddenDicts();
      if (hiddenDicts && hiddenDicts.length > 0) {
        searchParams.hide_dicts = hiddenDicts;
      }
    }

    if (window.SEARCH_HISTORY && window.SEARCH_HISTORY.getHiddenLangs) {
      var hiddenLangs = window.SEARCH_HISTORY.getHiddenLangs();
      if (hiddenLangs && hiddenLangs.length > 0) {
        searchParams.hide_langs = hiddenLangs;
      }
    }
    
    var urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has('debug')) {
      searchParams.debug = urlParams.get('debug');
    }
    
    return searchParams;
  }

  window.SEARCH_RESULTS_API_LOADER_UTILS = {
    checkEasterEgg: checkEasterEgg,
    cleanupOldResults: cleanupOldResults,
    buildSearchParams: buildSearchParams
  };
})();

